import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import styles from './resetPwForm.scss'
import FloatLabelInput from '../components/floatLabelInput/floatLabelInputComponent'
import { actionCreators as sagaActionCreators } from '../../redux/sagas/index'
import PropTypes from 'prop-types'

export function ResetPwForm (props) {
  const { t, handleSubmit } = props
  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <header>
        <h1 className={styles.modalHeader}>
          {t('form:forgotPassword')}
        </h1>
      </header>
      <Field
        name='email'
        component={FloatLabelInput}
        placeholder={t('form:placeholderEmail')}
        type='email'
        wrapperStyle={styles.formGroup}
        label={t('form:email')}
      />
      <button type='submit' className={styles.signInButton}>
        {t('form:resetPassword')}
      </button>
    </form>
  )
}
ResetPwForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

const boundActions = {
  onSubmit: sagaActionCreators.resetPwActionCreators.resetPw
}

export default compose(
  pure,
  translate(),
  reduxForm({
    form: 'resetPw'
  }),
  connect(state => ({}), boundActions)
)(ResetPwForm)



// WEBPACK FOOTER //
// ./src/forms/resetPw/resetPwForm.js